import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  ArrowIcon,
  BackArrowIcon,
  RadioBoxActiveIcon,
  RadioBoxInActiveIcon
} from "../../Assets/assets";
import { isValidObject } from "../../Services/validators";
import { getValidDateRange } from "../../Utils/Constants/Constants";
import Button from "../Button/Button";
import "./Filters.css";

export default function DateRange(props) {
  const dropdownRef = useRef(null);
  const [show, setShow] = useState(false);
  const [showCustomDateRange, setShowCustomDateRange] = useState(false);

  const getFilterSelected = () => {
    if (
      isValidObject(props.selected) &&
      typeof props.selected.type === "string" &&
      !props.selected.type.toLowerCase()?.includes("select")
    ) {
      return props.selected.type;
    } else {
      return `${props.selected.from} - ${props.selected.to}`;
    }
  };

  const handleSelect = (data) => {
    if (
      typeof data === "string" &&
      data.toLowerCase()?.includes("select") &&
      !showCustomDateRange
    ) {
      setShow(false);
      return setShowCustomDateRange(true);
    }
    props.setSelectedFilters({
      ...props.selectedFilters,
      [props.data.key]: getValidDateRange(data)
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
        setShowCustomDateRange(false);
      }
    };

    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        setShow(false);
        setShowCustomDateRange(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
    // eslint-disable-next-line
  }, []);

  const isFilterApplied = useMemo(() => {
    if (typeof props.isFilterApplied === "boolean") {
      return props.isFilterApplied;
    } else {
      const applied = props.appliedFilters?.[props.data.key];
      if (applied?.type && applied?.type !== "Lifetime") {
        return true;
      } else {
        return false;
      }
    }
    // eslint-disable-next-line
  }, [props.appliedFilters, props.isFilterApplied]);

  const isSelectedNotApplied = useMemo(() => {
    const selected = props.selectedFilters?.[props.data.key];
    const applied = props.appliedFilters?.[props.data.key];
    return !(
      selected?.from === applied?.from &&
      selected?.to === applied?.to &&
      selected?.type === applied?.type
    );
  }, [props.selectedFilters, props.appliedFilters, props.data.key]);

  return (
    <div
      data-cy={`${props?.["data-cy"]}-SELECT-FILTER`}
      style={{
        width: props.width || "fit-content"
      }}
      ref={dropdownRef}
      className={`${props.disabled ? "cursor-no-drop" : "cursor-pointer"}`}
    >
      <div
        onClick={() => {
          if (!props.disabled) {
            setShow(!show);
            setShowCustomDateRange(false);
          }
        }}
        style={{
          ...(show || isFilterApplied || showCustomDateRange
            ? {
                backgroundColor: "var(--tertiaryColor8)",
                border: "solid 1px var(--tertiaryColor5)"
              }
            : { border: "solid 1px transparent" }),
          ...(!show && isSelectedNotApplied
            ? { border: "solid 1px var(--tertiaryColor5)" }
            : {})
        }}
        className={`display-flex flex-align-items-center padding-default position-relative`}
      >
        {!show && isSelectedNotApplied && (
          <div
            style={{
              top: "-2px",
              right: "-2px",
              borderRadius: "50%",
              width: "7px",
              height: "7px",
              backgroundColor: "#1c1c1c",
              zIndex: 100
            }}
            className="position-absolute flex-justify-content-center flex-align-items-center"
          >
            <div
              style={{
                backgroundColor: "var(--secondaryColor)",
                width: "6px",
                height: "6px",
                borderRadius: "50%"
              }}
            />
          </div>
        )}
        <div className=" inherit-parent-width display-flex flex-justify-content-space-between flex-align-items-center">
          <div className="font-color-tertiaryColor6 font-size-small white-space-nowrap">
            {props.data.title}
          </div>
          <div className=" display-flex flex-align-items-center">
            <div className="font-size-medium font-color-tertiaryColor padding-left-small white-space-nowrap padding-right-small">
              {getFilterSelected()}
            </div>
            <div
              style={{
                height: "16px",
                width: "16px"
              }}
            >
              <ArrowIcon color="var(--tertiaryColor6)" />
            </div>
          </div>
        </div>
      </div>

      {show && props.data.options && !showCustomDateRange && (
        <div
          style={{
            height: "220px",
            width: "250px",
            top: "48px",
            zIndex: 200
          }}
          className="position-absolute padding-large box-shadow-default background-color-tertiaryColor2 font-color-tertiaryColor"
        >
          <div
            style={{ height: "calc(100% - 48px)" }}
            className="overflow-scroll inherit-parent-height inherit-parent-width"
          >
            {props.data.options?.map((data, i) => (
              <div
                data-cy={`${data?.toString().toUpperCase()}-${
                  props?.["data-cy"]
                }-SELECT-FILTER-OPTION`}
                key={i}
                className={`display-flex ${
                  i === 0 ? "" : "padding-top-default"
                } flex-align-items-center`}
                onClick={() => {
                  handleSelect(data);
                }}
              >
                <div
                  style={{
                    height: "16px",
                    width: "16px"
                  }}
                  className="margin-right-default display-flex font-color-tertiaryColor flex-align-items-center"
                >
                  {props.selectedFilters?.[props.data.key]?.type?.includes(
                    data
                  ) ? (
                    typeof data === "string" &&
                    props.appliedFilters?.[props.data.key]?.type?.includes(
                      data
                    ) ? (
                      <RadioBoxActiveIcon color="var(--secondaryColor)" />
                    ) : (
                      <RadioBoxActiveIcon color="var(--secondaryColor)" />
                    )
                  ) : (
                    <RadioBoxInActiveIcon />
                  )}
                </div>
                {data
                  ?.toString()
                  ?.toLowerCase()
                  ?.includes("select") ? (
                  <div className="display-flex inherit-parent-width flex-justify-content-space-between flex-align-items-center">
                    <div className="padding-right-default white-space-nowrap font-color-tertiaryColor">
                      {data}
                    </div>
                    <div
                      style={{
                        height: "16px",
                        width: "16px",
                        transform: "rotate(-90deg)"
                      }}
                    >
                      <ArrowIcon color="var(--tertiaryColor6)" />
                    </div>
                  </div>
                ) : (
                  <div className="white-space-nowrap font-color-tertiaryColor text-transform-capitalize">
                    {data}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div
            className={`display-flex margin-top-large ${
              props.data.options.length < 6 ? "" : "margin-bottom-large"
            } flex-justify-content-space-between`}
          >
            <div className="inherit-parent-width display-flex">
              {props.onApplyClick ? (
                <Button
                  data-cy={`${props?.["data-cy"]}-SELECT-APPLY-BUTTON`}
                  // variant="danger"
                  text="Apply"
                  boxShadow={false}
                  className={`inherit-parent-width padding-left-large padding-right-large margin-right-small ${
                    props.onApplyClick && props.onResetClick
                      ? "margin-right-small"
                      : ""
                  } `}
                  onClick={() => {
                    props.onApplyClick();
                    setShow(false);
                  }}
                  disabled={props.applyButtonDisabled}
                />
              ) : (
                <></>
              )}

              {props.onResetClick ? (
                <Button
                  data-cy={`${props?.["data-cy"]}-SELECT-RESET-BUTTON`}
                  variant="danger"
                  text="Reset"
                  boxShadow={false}
                  className={`inherit-parent-width padding-left-large padding-right-large ${
                    props.onApplyClick && props.onResetClick
                      ? "margin-left-small"
                      : ""
                  }`}
                  onClick={() => {
                    props.onResetClick(props.data.key);
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      )}

      {!show && showCustomDateRange && (
        <div
          style={{
            height: "220px",
            width: "250px",
            top: "48px",
            zIndex: 200
          }}
          className="position-absolute padding-large box-shadow-default background-color-tertiaryColor2 font-color-tertiaryColor"
        >
          <CustomDateRange
            setShowCustomDateRange={setShowCustomDateRange}
            showCustomDateRange={showCustomDateRange}
            data={props.data}
            setSelectedFilters={props.setSelectedFilters}
            selectedFilters={props.selectedFilters}
            multiple={props.multiple}
          />

          <div
            className={`display-flex margin-top-large ${
              props.data.options.length < 6 ? "" : "margin-bottom-large"
            } flex-justify-content-space-between`}
          >
            <div className="inherit-parent-width">
              <Button
                data-cy={`${props?.["data-cy"]}-CUSTOM-SELECT-RESET-BUTTON`}
                variant="danger"
                text="Reset"
                boxShadow={false}
                className="inherit-parent-width padding-left-large padding-right-large"
                onClick={() => {
                  props.onResetClick(props.data.key);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const CustomDateRange = (props) => {
  const [isFocused, setIsFocused] = useState({ from: false, to: false });
  const inputRefs = {
    from: useRef(null),
    to: useRef(null)
  };

  return (
    <div>
      <div className="display-flex">
        <div
          onClick={() => {
            props.setShowCustomDateRange(false);
          }}
          style={{
            width: "16px",
            height: "16px"
          }}
        >
          <BackArrowIcon color="var(--tertiaryColor6)" />
        </div>
        <div className="padding-left-default font-size-medium font-color-tertiaryColor">
          CUSTOM DATE RANGE
        </div>
      </div>

      {["FROM", "TO"].map((label) => {
        const key = label.toLowerCase();

        return (
          <div
            key={label}
            style={{
              borderBottom: `solid 1px ${
                isFocused[key]
                  ? "var(--tertiaryColor)"
                  : "var(--tertiaryColor4)"
              }`
            }}
            className="position-relative"
            onFocus={() => setIsFocused((prev) => ({ ...prev, [key]: true }))}
            onBlur={() => setIsFocused((prev) => ({ ...prev, [key]: false }))}
          >
            <div
              onFocus={() => setIsFocused((prev) => ({ ...prev, [key]: true }))}
              onBlur={() => setIsFocused((prev) => ({ ...prev, [key]: false }))}
              className="padding-top-large font-size-smaller"
            >
              {label}
            </div>
            <div style={{ position: "relative" }}>
              <input
                ref={inputRefs[key]}
                style={{
                  width: "100%",
                  border: "none",
                  backgroundColor: "transparent",
                  paddingBottom: "10px",
                  color: "var(--tertiaryColor6)",
                  colorScheme:
                    getComputedStyle(document.documentElement).getPropertyValue(
                      "--primaryColor"
                    ) === "#0E0E0E"
                      ? "dark"
                      : "light",
                  paddingRight: "28px"
                }}
                type="date"
                data-cy={`FILTER-${label}-FIELD`}
                value={props.selectedFilters?.[props.data.key]?.[key] || ""}
                onFocus={() =>
                  setIsFocused((prev) => ({ ...prev, [key]: true }))
                }
                onBlur={() =>
                  setIsFocused((prev) => ({ ...prev, [key]: false }))
                }
                onChange={(e) => {
                  props.setSelectedFilters({
                    ...props.selectedFilters,
                    [props.data.key]: {
                      ...props.selectedFilters[props.data.key],
                      [key]: e.target.value,
                      type: "Select Date"
                    }
                  });
                }}
              />
              <span
                onClick={() => inputRefs[key].current?.showPicker?.()}
                style={{
                  position: "absolute",
                  right: "14px",
                  width: "20px",
                  height: "100%",
                  cursor: "pointer"
                }}
              >
                <CalendarIcon />
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const CalendarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.5 2V3.5M11.5 2V3.5M2 12.5V5C2 4.60218 2.15804 4.22064 2.43934 3.93934C2.72064 3.65804 3.10218 3.5 3.5 3.5H12.5C12.8978 3.5 13.2794 3.65804 13.5607 3.93934C13.842 4.22064 14 4.60218 14 5V12.5M2 12.5C2 12.8978 2.15804 13.2794 2.43934 13.5607C2.72064 13.842 3.10218 14 3.5 14H12.5C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5M2 12.5V7.5C2 7.10218 2.15804 6.72064 2.43934 6.43934C2.72064 6.15804 3.10218 6 3.5 6H12.5C12.8978 6 13.2794 6.15804 13.5607 6.43934C13.842 6.72064 14 7.10218 14 7.5V12.5"
      stroke="var(--tertiaryColor6)"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
